import { useMemo, useState } from "react";
import {
  Box,
  Stack,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";

import FulfillmentsConnectorCoverageChart from "components/Shipping/Analytics/FulfillmentsConnectorCoverageChart";
import ExportsFTQChart from "components/Shipping/Analytics/ExportsFTQChart";
import ExportsStatsChart from "components/Shipping/Analytics/ExportsStatsChart";
import FulfillmentsFTQChart from "components/Shipping/Analytics/FulfillmentsConnectorFTQChart";
import PipelineHealthMetricsTable from "components/Shipping/Analytics/PipelineHealthMetricsTable";

const PipelinePerformanceChartsCollection: React.FC = () => {
  const [dateRange, setDateRange] = useState("3m");

  const today = useMemo(() => new Date().toISOString().split("T")[0], []);
  const threeMonthsAgo = useMemo(() => {
    const d = new Date();
    d.setMonth(d.getMonth() - 3);
    return d.toISOString().split("T")[0];
  }, []);

  const [dateStart, setDateStart] = useState(threeMonthsAgo);
  const [dateEnd, setDateEnd] = useState(today);

  const handleDateRangeChange = (
    event: React.MouseEvent<HTMLElement>,
    newDateRange: string | null
  ) => {
    if (newDateRange) {
      setDateRange(newDateRange);
      const today = new Date();
      let newDateStart = new Date(today);

      if (newDateRange === "3m") {
        newDateStart.setMonth(today.getMonth() - 3);
      } else if (newDateRange === "1y") {
        newDateStart.setFullYear(today.getFullYear() - 1);
      } else if (newDateRange === "all") {
        newDateStart = new Date("2023-01-01"); // Project start date
      }

      setDateStart(newDateStart.toISOString().split("T")[0]);
      setDateEnd(today.toISOString().split("T")[0]);
    }
  };

  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 5 }}>
        <Stack direction="row" spacing={2} alignItems="flex-end">
          <TextField
            label="Start Date"
            type="date"
            value={dateStart}
            onChange={(e) => {
              setDateStart(e.target.value);
              setDateRange(""); // Clear toggle button selection
            }}
            InputLabelProps={{
              shrink: true,
            }}
            size="small"
          />
          <TextField
            label="End Date"
            type="date"
            value={dateEnd}
            onChange={(e) => {
              setDateEnd(e.target.value);
              setDateRange(""); // Clear toggle button selection
            }}
            InputLabelProps={{
              shrink: true,
            }}
            size="small"
          />
          <Stack>
            <Typography
              variant="body2"
              sx={{ color: "text.secondary", mb: 0.5 }}
            >
              Quick Select:
            </Typography>
            <ToggleButtonGroup
              value={dateRange}
              exclusive
              onChange={handleDateRangeChange}
              aria-label="date range"
              size="small"
            >
              <ToggleButton value="3m" aria-label="3 months" sx={{ px: 2 }}>
                3m
              </ToggleButton>
              <ToggleButton value="1y" aria-label="1 year" sx={{ px: 2 }}>
                1y
              </ToggleButton>
              <ToggleButton value="all" aria-label="all time" sx={{ px: 2 }}>
                All
              </ToggleButton>
            </ToggleButtonGroup>
          </Stack>
        </Stack>
      </Box>
      <ExportsFTQChart dateStart={dateStart} dateEnd={dateEnd} />
      <ExportsStatsChart dateStart={dateStart} dateEnd={dateEnd} />
      <FulfillmentsFTQChart dateStart={dateStart} dateEnd={dateEnd} />
      <FulfillmentsConnectorCoverageChart
        dateStart={dateStart}
        dateEnd={dateEnd}
      />
      <PipelineHealthMetricsTable dateStart={dateStart} dateEnd={dateEnd} />
    </>
  );
};

export default PipelinePerformanceChartsCollection;
